import $ from "jquery";

const storeFinder = {
    bindCountryFilter() {
        $('#country-filter').select2({
            width: '100%',
            minimumResultsForSearch: Infinity
        }).change(function () {
            $('#search-input').val('');
            storeFinder.filterTable();
        });
    },
    bindSearchInput() {
        $('#search-input').keyup(function () {
            storeFinder.filterTable();
        });
    },
    bindSortTable() {
        $('#storefinder-table thead tr th').each((index, element) => {
            $(element).click(function () {
               storeFinder.sortTable(index);
            });
        });
    },
    filterTable() {
        var countryId = $('#country-filter').val();
        var input = $('#search-input').val().toUpperCase();

        $('#storefinder-table tbody tr').each((index, element) => {
            var txtValue = $(element).find('td:nth-child(1)').html() +
                $(element).find('td:nth-child(2)').html() +
                $(element).find('td:nth-child(3)').html() +
                $(element).find('td:nth-child(4)').html();

            if ($(element).attr('countryId') === countryId && txtValue.toUpperCase().indexOf(input) > -1) {
                $(element).show();
            } else {
                $(element).hide();
            }
        });
    },
    sortTable(n) {
        var table, rows, switching, i, x, y, shouldSwitch, dir, switchcount = 0;
        table = document.getElementById('storefinder-table');
        switching = true;
        // Set the sorting direction to ascending:
        dir = 'asc';
        /* Make a loop that will continue until
         no switching has been done: */
        while (switching) {
            // Start by saying: no switching is done:
            switching = false;
            rows = table.rows;
            /* Loop through all table rows (except the
             first, which contains table headers):*/
            for (i = 1; i < (rows.length - 1); i++) {
                // Start by saying there should be no switching:
                shouldSwitch = false;
                /* Get the two elements you want to compare,
                 one from current row and one from the next: */
                x = rows[i].getElementsByTagName('TD')[n];
                y = rows[i + 1].getElementsByTagName('TD')[n];
                /* Check if the two rows should switch place,
                 based on the direction, asc or desc: */
                if (dir === 'asc') {
                    if (x.innerHTML.toLowerCase() > y.innerHTML.toLowerCase()) {
                        // If so, mark as a switch and break the loop:
                        shouldSwitch = true;
                        break;
                    }
                } else if (dir === 'desc') {
                    if (x.innerHTML.toLowerCase() < y.innerHTML.toLowerCase()) {
                        // If so, mark as a switch and break the loop:
                        shouldSwitch = true;
                        break;
                    }
                }
            }
            if (shouldSwitch) {
                /* If a switch has been marked, make the switch
                 and mark that a switch has been done: */
                rows[i].parentNode.insertBefore(rows[i + 1], rows[i]);
                switching = true;
                // Each time a switch is done, increase this count by 1:
                switchcount++;
            } else {
                /*If no switching has been done AND the direction is 'asc',
                 set the direction to 'desc' and run the while loop again.*/
                if (switchcount === 0 && dir === 'asc') {
                    dir = 'desc';
                    switching = true;
                }
            }
        }
    }
};

// DOM ready
$(() => {
    if ($('.storefinder').length) {
        storeFinder.filterTable();
        storeFinder.bindCountryFilter();
        storeFinder.bindSearchInput();
        storeFinder.bindSortTable();
    }
});

export default storeFinder;
